import Vue from "vue";
import axios from "axios";

//Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;
Vue.prototype.$storeUm6p = {
  ValidCandidat: false,
  Formulaire: {
    // Formulaire
    Id: null,
    ReadOnly: false,
    CandidatMarocain: false,
    LienDocumentDgi: null,
    LienDocumentSalaire: null,
    PublipostageSigne: {
      NomFichier: null,
      DonneePieceJointe: null,
    },
    // identité
    Nom: null,
    Prenom: null,
    Genre: null,
    DateNaissance: null,
    LieuNaissance: null,
    SituationFamiliale: null,
    Nationalite: null,
    AutreNationalite: null,
    Mail: null,
    Cni: null,
    NoPasseport: null,
    Portable: null,
    Fixe: null,
    SituationHandicap: null,
    TypeHandicap: null,
    // Si candidat marocain
    AdresseMaroc: null,
    VilleMaroc: null,
    ProvinceMaroc: null,
    RegionMaroc: null,
    ConditionsGenerales: false,
    CpMaroc: null,
    PaysMaroc: null,
    // Si candidat étranger
    AdresseAutre: null,
    VilleAutre: null,
    RegionFrance: null,
    DepartementFrance: null,
    CpAutre: null,
    PaysAutre: null,
    // Etat familial
    EtesVous: null,
    //Si à la charge d’un de mes deux parents, divorcé(e) ou veuf (ve)
    GardeConfiee: null,
    ParentTuteurDivorce: null,
    ParentTuteurVeuf: null,
    // Situation financiere et pro
    VousEtes: null,
    RevenuNetMensuel: null,
    ProtectionSociale: null,
    OrganismeProtectionSociale: null,
    NombreCompteBancaire: null,
    BourseSupplementaire: null,
    Beneficiaire: false,
    NomAutreBourse: null,
    MontantAnnuelleAutreBourse: null,
    DateFinBourse: null,
    ListeProprietesCandidat: [],
    AnneeRevenue: null,
    AutresRevenusCandidat: {
      Supprimer: false,
      PersonneConcernee: 5024,
      FinancementPropriete: 5047,
      CandidatureBourse: null,
      CandidatureBourseFirsi: null,
      SituationFamiliale: null,
      IdCrypte: null,
      RevenuAgricole: null,
      RevenuLocatifNet: null,
      Dividendes: null,
      AutresRevenus: null,
      ProduitVenteBien: null,
      Heritage: null,
      AutresRevenusExceptionnels: null,
      NatureRevenus: null,
      NatureRevenusExceptionnels: null,
    },
    ListeAnnexesFirsi: [],
  },
  ItemLang: "lang00",
  Label: {
    Valider: "Valider",
    Annuler: "Annuler",
    Ajouter: "Ajouter",
    Modifier: "Modifier",
    Suivant: "Suivant",
    Enregistrer: "Enregistrer",
    Soumettre: "Soumettre ma demande",
    Precedent: "Précèdent",
    SupprimerLigne: "Etes-vous sûr de vouloir supprimer cette ligne ?",
    AfficherDocument: "Afficher le document",
    Informations: "Informations",
    AdressePrincipaleCompte: "Cette adresse sera utilisée comme adresse principale de votre compte et servira pour la réinitialisation de votre mot de passe.",
    Fermer: "Fermer",
    Oui: "Oui",
    Non: "Non",
    Resume: "Résumé de votre demande",
    Annexes: {
      TailleMaximale: "Taille maximum du fichier : 8Mo",
      TailleMaximaleDepassee: "Taille maximale du fichier dépassée.",
      AnnexesObligatoires:
        "Annexes - Veuillez ajouter toutes les annexes obligatoires",
      SoumissionAnnexes: 'Veuillez soumettre les annexes sur l\'onglet "Document"',
      AjouterPj: "Ajouter une pièce jointe",
      TypePiece: "Type de pièce",
      SelectionnerDocument: "Sélectionner votre document",
      FormatsAcceptes: "Formats acceptés : pdf et images (jpg, jpeg et png)",
      FormatsAcceptesPdf: "Formats acceptés : pdf uniquement",
      FichierSelectionne: "Fichier sélectionné :",
      AfficherDocument: "Afficher le document",
      ListeVide: "La liste est vide",
      FichierManquant: "Fichier manquant",
      SupprimerDocument: "Etes-vous sûr de vouloir supprimer ce document ?",
      FormatNonSupporte: "Format non supporté",
      VeuillezTelecharger: "Veuillez télécharger",
      CeDocument: "ce document",
      SignerDeposer:
        "afin de le signer et le légaliser par le candidat et les parents ou le tuteur (cas échéant) puis de le déposer dans la rubrique suivante",
      Header: [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    },
    StepperHeaders: [
      "Introduction",
      "Candidat",
      "Fratrie",
      "Parents / Tuteurs",
      "Revenus",
      "Pour finir",
    ],
    Title: {
      Candidat: "Candidat",
      Adresses: "Adresses",
      EtatFamilial: "Etat familial",
      SituationFinanciere: "Situation financière du candidat",
      Bourse: "Bourse",
      Fratrie: "Fratrie",
      SituationFamiliale: "Situation familiale",
      Revenus: "Revenus",
    },
    Candidat: {
      Nom: "Nom",
      Prenom: "Prénom",
      Genre: "Genre",
      DateNaissance: "Date de naissance",
      LieuNaissance: "Lieu de naissance",
      SituationFamiliale: "Situation familiale",
      Nationalite: "Nationalité",
      AutreNationalite: "Autre nationalité",
      Mail: "Adresse électronique",
      Cni: "N° CNI",
      NoPasseport: "N° passeport",
      Portable: "Télephone portable",
      Fixe: "Téléphone fixe",
      SituationHandicap: "Situation de handicap",
      TypeHandicap: "Type de handicap",
      AdresseMaroc: "Adresse",
      AdresseMa: "Adresse",
      AdresseAu: "Autre adresse",
      Adresses: "Adresses",
      VilleMaroc: "Ville",
      ProvinceMaroc: "Province",
      RegionMaroc: "Région",
      CpMaroc: "Code postal",
      PaysMaroc: "Pays",
      AdresseAutre: "Adresse",
      VilleAutre: "Ville",
      RegionFrance: "Région",
      DepartementFrance: "Departement",
      CpAutre: "Code postal",
      PaysAutre: "Pays",
      EtesVous: "Êtes-vous ?",
      GardeConfiee: "Garde confiée à ",
      ParentTuteurDivorce: "Parent tuteur divorcé",
      ParentTuteurVeuf: "Parent tuteur veuf",
      VousEtes: "Vous êtes :",
      RevenuNetMensuel: "Revenu net mensuel",
      ProtectionSociale: "Disposez-vous d’un régime de protection sociale ? ",
      OrganismeProtectionSociale:
        "Si oui, veuillez préciser auprès de quel organisme ",
      NombreCompteBancaire: "Nombre de compte bancaire",
      BourseSupplementaire:
        "Bénéficiez-vous d’une bourse supplémentaire pour vos études ? ",
      Beneficiaire: "Êtes-vous bénéficiaire d'une bourse Mastercard Fondation ? ",
      NomAutreBourse: "Le nom de l'organisme",
      MontantAnnuelDirham: "Montant annuel en DHS",
      DateFinBourse: "Date de la fin de cette bourse",
      DateDebutBourse: "Date de début de cette bourse",
    },
    Fratrie: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Date de naissance", value: "datenaissance" },
        { text: "En situation de handicap", value: "situationhandicap" },
        { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],
      Nom: "Nom",
      Prenom: "Prénom",
      DateNaissance: "Date de naissance",
      SituationHandicap: "En situation de handicap ?",
      TypeHandicap: "Type de handicap",
      NomPere: "Nom et prénom du père",
      NomMere: "Nom et prénom de la mère",
      MsgDoublon: "Une personne avec le même nom, prénom et date de naissance existe déjà dans la liste.",
    },
    Parents: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Lien parenté", value: "lienparente" },
        { text: "Situation familiale", value: "situationfamiliale" },
        { text: "", value: "actions", sortable: false },
      ],
      LienParenteTuteur: "Lien parenté du tuteur légal",
      MsgSituationParents:
        "Vous avez indiqué être à la charge de deux parents mariés, merci de corriger la situation familiale de vos parents.",
      MsgSituationParentVeuf:
        "Veuillez renseigner tous les champs demandés du parent décédé.",
      MsgParentsMaries:
        "Vous avez indiqué être à la charge de deux parents mariés, merci d'ajouter ici vos deux parents.",
      MsgParentVeuf:
        "Vous avez indiqué être à la charge de l'un de mes deux parents veuf(ve), merci d'ajouter ici vos deux parents.",
      MsgTuteur:
        "Merci de renseigner au moins un tuteur. Auquel cas, merci de revenir à l'étape 'Informations personnelles' et de sélectionner l'option 'Orphelin des deux parents, sans tuteur légal et/ou dépendant d’un orphelinat' dans la partie 'Candidat'",
      MsgTuteurMere:
        "Vous avez indiqué être à la charge de votre mère, merci de vérifier votre saisie.",
      MsgTuteurPere:
        "Vous avez indiqué être à la charge de votre père, merci de vérifier votre saisie.",
      DateDepartRetraite: "Date de départ retraite",
      Tuteur: "Tuteur légal",
      Nom: "Nom",
      Prenom: "Prénom",
      Civilite: "Civilité",
      Nationalite: "Nationalité",
      AutreNationalite: "Autre nationalité",
      SituationFamiliale: "Situation familiale",
      Cni: "N° CNI",
      AutreCni: "N° de la pièce d’identité nationale/N° passeport",
      NoPasseport: "N° passeport",
      LienParental: "Lien parental",
      SituationHandicap: "Situation de handicap",
      TypeHandicap: "Type de handicap",
      AdresseElectronique: "Adresse electronique",
      AdressePermanante: "Adresse permanente",
      AdresseSecondaire: "Adresse secondaire",
      Portable: "Portable",
      Fixe: "Fixe",
      //Situationfinanciere
      TypeOrganisme: "Type d'organisme",
      BeneficiaireAssurance:
        "Bénéficiaire d'une assurance maladie complémentaire/ retraite complémentaire ?",
      Mutuelle: "Mutuelle",
      Secteur: "Secteur d'activité professionel",
      Profession: "Profession",
      EtatProfessionnel: "Etat professionnel",
      SituationProfessionnel: "Situation professionnelle",
      NomEmployeur: "Nom d'organisme ou d'employeur",
      RnmNet: "Revenu net Mensuel si autre que non actif (ve) ",
      AMO_TADAMON:
        "Disposez-vous du régime de protection sociale AMO TADAMON? ",
      RegimeProtection:"Disposez-vous d’un régime de protection sociale ?",
      AutreRegimeProtection:
        "Si non , Disposez-vous d’un autre régime de protection sociale ? ",
      SituationASaisir:
        "Vos parents ou votre tuteur légal ont ils des crédits auprès d'établissements de crédit ?",
      BienImmoSecondaireParentsTuteurs:
        "Vos parents ou votre tuteur légal sont-ils propriétaires de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc ?",
      QuelOrganisme: "Si oui, veuillez préciser auprès de quel organisme ",
      NombreCompteBancaire: "Nombre de compte bancaire",
      AssocieOuGerantSociete:
        "Ce parent/ tuteur légal est-il associé ou gérant associé au sein d'une société ? ",
      PreciserSociete: "Précisez le nom de la société",
      FraisUnivEmployeur:
        "Vos parents ou votre tuteur légal bénéficient-ils de la prise en charge partielle ou totale des frais universitaires de leurs enfants par leurs employeurs ?",
      MontantBourseAnnuelle: "Le montant de la bourse annuelle",
      CompteEpargne:
        "Vos parents, votre tuteur légal ou vous-même, possédez-vous des comptes épargnes ?",
      MontantEpargne: "Le montant total de l'épargne",
      ValeurImmobiliere:
        "Vos parents ou tuteur légal sont-ils porteurs/ souscripteurs de valeurs mobilières (actions, obligations, OPCVM, etc.)",
      ValeurImmobiliereItem: "Valeurs mobilière",
      ValeurTotaleTitres: "La valeur totale de ces titres",
      ChargeFraisUniv: "Prise en charge des frais universitaire",
      MontantBourse: "Le montant total annuel",
      CompteEpargneItem: "Compte épargne",
      DepotsTermes:
        "Vos parents ou votre tuteur légal possèdent-ils des dépôts à terme * ? Le Dépôt À Terme est une somme d’argent bloquée auprès d’une banque, pour une période déterminée, produisant des intérêts en faveur du souscripteur (déposant).",
      MontantDuCapital: "Préciser le montant du capital",
      CompleterRevenus: "Compléter les revenus ",
      AjouterCredits: "Ajouter la liste des crédits pour ",
      AjouterBiensImmo: "Ajouter la liste des biens immobiliers pour ",
    },
    Revenus: {
      Headers: [
        { text: "Lien parenté", value: "parente" },
        { text: "Voir les détails", value: "actions", sortable: false },
      ],
      RenseignerTousLesChamps:
        "Tous les champs doivent être renseignés même si nuls.",
      RenseignerRevenus: "Renseigner les revenus",
      RevenuMensuelNetDeclare: "Revenu mensuel net declaré (1)",
      HorsPension: "Hors pension de retraite et de veuvage",
      RevenuNetAnnuelAttestation:
        "Revenu Net Annuel Imposable figurant sur l'attestation Salaire annuel",
      RevenuNetMensuelAttestation:
        "Revenu Net Mensuel figurant sur l'attestation Salaire annuel",
      PhraseExplicativeRevenuNetMensuelAttestation:
        "Diviser le revenu net annuel figurant sur l'attestation Salaire annuel sur / 12",
      RevenuNetMensuelBulletinRecent:
        "Revenu Net Mensuel figurant sur le bulletin de paie le plus récent",
      RevenuNetMensuelBulletinDecembre:
        "Revenu Net Mensuel figurant sur le bulletin de paie de décembre N-1",
      SommeMensuelPensions:
        "Somme des Revenus Nets Mensuels figurant sur toutes les attestations de toutes les pensions perçues",
      AllocationPere:
        "Allocations familiales (versées par le père aux enfants)",
      PensionMere:
        "Somme des Revenus Nets Mensuels figurant sur toutes les attestations de toutes les pensions perçues par la mère",
      RevenuNetAnnuelDgi:
        "Revenu Net Imposable Annuel figurant sur l'attestation DGI",
      AutreRevenuNetAnnuel: "Autre revenu net mensuel (2)",
      Note1:
        "(1) salaires nets, honoraires, CIMR, et autres pensions, rentes, loyers mensuels, autres revenus mensuels … (les revenus mensuels nets ne doivent pas tenir compte des dépenses spécifiques tels que les crédits, les personnes à charge et autres dépenses personnelles).",
      Note2:
        "(2) autre que :revenus agricoles, dividendes, revenus locatifs, autres revenus nets annuels perçus, produits résultants de la vente de biens immobiliers, héritages et autres revenus exceptionnels.",
      RevenuAnnuelGlobal:
        "Revenus annuels comme figurent sur l'attestation du revenu global.",
      NatureDesRevenus: "Nature des revenus",
      CAHT: "Chiffre d'affaires déclaré H.T",
      MontantRevenuNetImp: "Montant du revenu net imposable",
      Employeur: "Nom ou raison sociale de l'employeur",
      RevenusProfessionnels: "Revenus professionnels",
      RevenusAgricoles: "Revenus agricoles",
      RevenusSalariaux: "Revenus salariaux et assimilés",
      RevenusFonciers: "Revenus fonciers",
      RevenusCapitauxImmo: "Revenus de capitaux mobiliers",
      RevenusSourcesEtrangeres: "Revenus et profits de sources étrangères",
      RevenusCompleterTuteurs:
        "Les revenus à compléter portent sur les parents/tuteurs où la rubrique'Tuteur(rice)' est \"Oui\"",
      ModeleAttestationSalarie:
        "Modèle Attestation Salaire Annuel que pour les salariés",
      ModeleAttestationDgi: "Modèle Attestation Revenus DGI",
      InfoRenseignementChampsObligatoire: "Tout les champs obligatoires ne sont pas été renseigné.",
    },
    AutresRevenus: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Lien parenté", value: "lienparente" },
        { text: "Total revenus mensuels en dirhams", value: "trmd" },
        { text: "Total autres revenus annuels en dirhams", value: "tarad" },
        { text: "Total revenus exceptionnels en dirhams", value: "tred" },
        { text: "", value: "actions", sortable: false },
      ],
      RevenusLocatifNef: "Revenu locatif net annuel",
      RevenuNetMensuelDirham: "Revenus mensuels en dirhams",
      RevenuNetMensuelMoyen: "Revenu / salaire net mensuel moyen (*)",
      Inclure13Mois:
        "(Il faut inclure le 13 éme mois et les primes et gratifications annuelles)",
      PensionNetteMensuelleRetraire:
        "Pension nette menuselle (en cas de retraite)",
      PensionVeuvage:
        "Pension de veuvage nette mensuelle (en cas de décès de l'un des parents)",
      AllocationDivorce:
        "Allocations familales nettes mensuelles (en cas de divorce)",
      RevenuLocatif: "Revenu locatif net mensuel",
      AutresRevenusNetMensuel: "Autres revenus nets mensuels perçus",
      TotalRevenusNetsMensuels: "Total revenus nets mensuels",
      AutresRevenusAnnuelsDirham: "Autres revenus annuels en dirhams",
      AutresRevenusTitle: " reçu durant l’année ",
      RevenusAgricolesAnnuels: "Revenus agricoles annuels nets",
      Dividendes: "Dividendes (1)",
      AutreRevenusNetAnnuels: "Autres revenus nets annuels perçus",
      PrecisezLaNature: "(Il faut préciser la nature du revenu)",
      TotalAutresRevenusAnnuel: "Total autres revenus annuels",
      PrecisezLaNatureExc: "Pécisez la nature du revenu exceptionnel",
      RevenuExceptionnels: "Revenus exceptionnels en dirhams",
      NatureAutresRevenus: "Nature des autres revenus",
      ProduitVenteImmo: "Produits résultant de la vente de biens immobiliers",
      Heritages: "Héritages",
      AutresRevenusExceptionnels: "Autres revenus exceptionnels perçus",
      TotalRevenusExceptionnels: "Total revenus exceptionnels",
      NB1: "N.B. : Insérer « 0 » dans les champs qui ne s'appliquent pas à votre situation.",
      NB2: "(*) Les revenus mensuels nets ne doivent pas tenir compte des dépenses spécifiques tels que les crédits, les personnes à charge et autres dépenses personnelles.",
      NB3: "(1) Bénéfice versé par une société à un actionnaire.",
      LabelTableauCredit:
        "Si vos parents ou votre tuteur légal ont des crédits auprès d'établissements de crédit, veuillez remplir le tableau ci-dessous :",
      TypeFinancement: "Type de financement (1)",
      MontantGlobal: "Montant global",
      Duree: "Durée en mois",
      MontantEcheance: "Montant d'échéance",
      LabelTableauBiensImmo:
        "Vos parents ou votre tuteur légal sont-ils propriétaires de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc",
      Proprietaire: "Propriétaire",
      NombreBiens: "Nombre de biens",
      NatureBien: "Nature du bien",
      AdresseBien: "Adresse du bien",
      NumeroTitreFoncier: "Numéro du titre foncier",
      DateAcquisitionBien: "Date d’acquisition du bien",
      ValeurAcquisitionBien: "Valeur d’acquisition du bien",
      ValeurEstimativeBien: "Valeur estimative actuelle du bien",
      SourceEstimationBien: "Source d’estimation de la valeur actuelle du bien",
      RevenuBien:
        "Si le bien génère un revenu locatif, veuillez préciser le revenu",
      SuperficieBien: "Superficie du bien en m2",
      CandidatProprietaire:
        "Etes-vous propriétaire de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc ?.",
      PopupNBBienImmo:
        "N.B. : Ce tableau concerne uniquement les biens autres que la résidence principale du foyer. <br>Renseigner uniquement les biens immobiliers secondaires. <br>1. Terrain, bien immobilier, local commercial, etc.<br>2. Superficie de la villa, Superficie terrain agricole, superficie de l’appartement, R+1, R+2, R+3, etc.<br>3. Source d’estimation de la valeur actuelle du bien : Notaire, expert immobilier agréé, cadastre/direction générale des impôts, etc.<br>4. Si vous possédez un bien en copropriété (partagé avec un ou plusieurs autres propriétaire), veuillez indiquer uniquement la valeur estimative actuelle de votre part dans ce bien.",
      PopupNBBienImmoECC:
        "N.B. : Ce tableau concerne uniquement les biens autres que la résidence principale du foyer. <br>1. Terrain, bien immobilier, local commercial, etc.<br>2. Superficie de la villa, Superficie terrain agricole, superficie de l’appartement, R+1, R+2, R+3, etc.<br>3. Source d’estimation de la valeur actuelle du bien : Notaire, expert immobilier agréé, cadastre/direction générale des impôts, etc.<br>4. Si vous possédez un bien en copropriété (partagé avec un ou plusieurs autres propriétaire), veuillez indiquer uniquement la valeur estimative actuelle de votre part dans ce bien.",
      RenseignementRevenuMensuel: "Veuillez renseigner le revenu mensuel déclaré",
      RenseignementRevenuMensuelPension: "Veuillez renseigner le revenu mensuel déclaré et la pension de retraite",
      RenseignementPensionRentraite: "Veuillez renseigner la pension de retraite",
    },
    Bourse: {
      HeadersTab: [
        { text: "Organisme", value: "organisme" },
        { text: "Début", value: "debut" },
        { text: "Fin", value: "fin" },
        { text: "Montant annuel en DHS", value: "montantdirham" },
        { text: "", value: "actions", sortable: false },
      ],
    },
  },
  LabelFR: {
    Valider: "Valider",
    Annuler: "Annuler",
    Ajouter: "Ajouter",
    Modifier: "Modifier",
    Suivant: "Suivant",
    Enregistrer: "Enregistrer",
    Soumettre: "Soumettre ma demande",
    Precedent: "Précèdent",
    SupprimerLigne: "Etes-vous sûr de vouloir supprimer cette ligne ?",
    AfficherDocument: "Afficher le document",
    Informations: "Informations",
    Fermer: "Fermer",
    Resume: "Résumé de votre demande",
    Oui: "Oui",
    Non: "Non",
    Annexes: {
      TailleMaximale: "Taille maximum du fichier : 8Mo",
      TailleMaximaleDepassee: "Taille maximale du fichier dépassée.",
      AnnexesObligatoires:
        "Annexes - Veuillez ajouter toutes les annexes obligatoires",
      SoumissionAnnexes: 'Veuillez soumettre les annexes sur l\'onglet "Document"',
      AjouterPj: "Ajouter une pièce jointe",
      TypePiece: "Type de pièce",
      SelectionnerDocument: "Sélectionner votre document",
      FormatsAcceptes: "Formats acceptés : pdf et images (jpg, jpeg et png)",
      FormatsAcceptesPdf: "Formats acceptés : pdf uniquement",
      FichierSelectionne: "Fichier sélectionné :",
      AfficherDocument: "Afficher le document",
      ListeVide: "La liste est vide",
      FichierManquant: "Fichier manquant",
      SupprimerDocument: "Etes-vous sûr de vouloir supprimer ce document ?",
      FormatNonSupporte: "Format non supporté",
      VeuillezTelecharger: "Veuillez télécharger",
      CeDocument: "ce document",
      SignerDeposer:
        "afin de le signer et le légaliser par le candidat et les parents ou le tuteur (cas échéant) puis de le déposer dans la rubrique suivante",
      Header: [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    },
    StepperHeaders: [
      "Introduction",
      "Candidat",
      "Fratrie",
      "Parents / Tuteurs",
      "Revenus",
      "Pour finir",
    ],
    Title: {
      Candidat: "Candidat",
      Adresses: "Adresses",
      EtatFamilial: "Etat familial",
      SituationFinanciere: "Situation financière du candidat",
      Bourse: "Bourse",
      Fratrie: "Fratrie",
      SituationFamiliale: "Situation familiale",
      Revenus: "Revenus",
    },
    Candidat: {
      Nom: "Nom",
      Prenom: "Prénom",
      Genre: "Genre",
      DateNaissance: "Date de naissance",
      LieuNaissance: "Lieu de naissance",
      SituationFamiliale: "Situation familiale",
      Nationalite: "Nationalité",
      AutreNationalite: "Autre nationalité",
      Mail: "Adresse électronique",
      Cni: "N° CNI",
      NoPasseport: "N° passeport",
      Portable: "Télephone portable",
      Fixe: "Téléphone fixe",
      SituationHandicap: "Situation de handicap",
      TypeHandicap: "Type de handicap",
      AdresseMaroc: "Adresse",
      AdresseMa: "Adresse",
      AdresseAu: "Autre adresse",
      VilleMaroc: "Ville",
      ProvinceMaroc: "Province",
      RegionMaroc: "Région",
      CpMaroc: "Code postal",
      PaysMaroc: "Pays",
      AdresseAutre: "Adresse",
      VilleAutre: "Ville",
      RegionFrance: "Région",
      DepartementFrance: "Departement",
      CpAutre: "Code postal",
      PaysAutre: "Pays",
      EtesVous: "Êtes-vous ?",
      GardeConfiee: "Garde confiée à ",
      ParentTuteurDivorce: "Parent tuteur divorcé",
      ParentTuteurVeuf: "Parent tuteur veuf",
      VousEtes: "Vous êtes :",
      RevenuNetMensuel: "Revenu net mensuel",
      ProtectionSociale: "Disposez-vous d’un régime de protection sociale ? ",
      OrganismeProtectionSociale:
        "Si oui, veuillez préciser auprès de quel organisme ",
      NombreCompteBancaire: "Nombre de compte bancaire",
      BourseSupplementaire:
        "Bénéficiez-vous d’une bourse supplémentaire pour vos études ? ",
      Beneficiaire: "Êtes-vous bénéficiaire d'une bourse Mastercard Fondation ?",
      NomAutreBourse: "Le nom de l'organisme",
      MontantAnnuelDirham: "Montant annuel en DHS",
      DateFinBourse: "Date de la fin de cette bourse",
      DateDebutBourse: "Date de début de cette bourse",
    },
    Fratrie: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Date de naissance", value: "datenaissance" },
        { text: "En situation de handicap", value: "situationhandicap" },
        { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],
      Nom: "Nom",
      Prenom: "Prénom",
      DateNaissance: "Date de naissance",
      SituationHandicap: "En situation de handicap ?",
      TypeHandicap: "Type de handicap",
      NomPere: "Nom et prénom du père",
      NomMere: "Nom et prénom de la mère",
      MsgDoublon: "Une personne avec le même nom, prénom et date de naissance existe déjà dans la liste.",
    },
    Parents: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Lien parenté", value: "lienparente" },
        { text: "Situation familiale", value: "situationfamiliale" },
        { text: "", value: "actions", sortable: false },
      ],
      LienParenteTuteur: "Lien parenté du tuteur légal",
      MsgSituationParents:
        "Vous avez indiqué être à la charge de deux parents mariés, merci de corriger la situation familiale de vos parents.",
      MsgSituationParentVeuf:
        "Veuillez renseigner tous les champs demandés du parent décédé.",
      MsgParentsMaries:
        "Vous avez indiqué être à la charge de deux parents mariés, merci d'ajouter ici vos deux parents.",
      MsgParentVeuf:
        "Vous avez indiqué être à la charge de l'un de mes deux parents veuf(ve), merci d'ajouter ici vos deux parents.",
      MsgTuteur:
        "Merci de renseigner au moins un tuteur. Auquel cas, merci de revenir à l'étape 'Informations personnelles' et de sélectionner l'option 'Orphelin des deux parents, sans tuteur légal et/ou dépendant d’un orphelinat' dans la partie 'Candidat'",
      MsgTuteurMere:
        "Vous avez indiqué être à la charge de votre mère, merci de vérifier votre saisie.",
      MsgTuteurPere:
        "Vous avez indiqué être à la charge de votre père, merci de vérifier votre saisie.",
      DateDepartRetraite: "Date de départ retraite",
      Tuteur: "Tuteur légal",
      Nom: "Nom",
      Prenom: "Prénom",
      Civilite: "Civilité",
      Nationalite: "Nationalité",
      AutreNationalite: "Autre nationalité",
      SituationFamiliale: "Situation familiale",
      Cni: "N° CNI",
      AutreCni: "N° de la pièce d’identité nationale/N° passeport",
      NoPasseport: "N° passeport",
      LienParental: "Lien parental",
      SituationHandicap: "Situation de handicap",
      TypeHandicap: "Type de handicap",
      AdresseElectronique: "Adresse electronique",
      AdressePermanante: "Adresse permanente",
      AdresseSecondaire: "Adresse secondaire",
      Portable: "Portable",
      Fixe: "Fixe",
      //Situationfinanciere
      Secteur: "Secteur d'activité professionel",
      BeneficiaireAssurance:
        "Bénéficiaire d'une assurance maladie complémentaire/ retraite complémentaire ?",
      Mutuelle: "Mutuelle",
      EtatProfessionnel: "Etat professionnel",
      Profession: "Profession",
      TypeOrganisme: "Type d'organisme",
      SituationProfessionnel: "Situation professionnelle",
      NomEmployeur: "Nom d'organisme ou d'employeur",
      RnmNet: "Revenu net Mensuel si autre que non actif (ve) ",
      AMO_TADAMON:
        "Disposez-vous du régime de protection sociale AMO TADAMON? ",
      RegimeProtection:"Disposez-vous d’un régime de protection sociale ?",
      AutreRegimeProtection:
        "Si non , Disposez-vous d’un autre régime de protection sociale ? ",
      SituationASaisir:
        "Vos parents ou votre tuteur légal ont ils des crédits auprès d'établissements de crédit ?",
      BienImmoSecondaireParentsTuteurs:
        "Vos parents ou votre tuteur légal sont-ils propriétaires de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc ?",
      QuelOrganisme: "Si oui, veuillez préciser auprès de quel organisme ",
      NombreCompteBancaire: "Nombre de compte bancaire",
      AssocieOuGerantSociete:
        "Ce parent/ tuteur légal est-il associé ou gérant associé au sein d'une société ? ",
      PreciserSociete: "Précisez le nom de la société",
      FraisUnivEmployeur:
        "Vos parents ou votre tuteur légal bénéficient-ils de la prise en charge partielle ou totale des frais universitaires de leurs enfants par leurs employeurs ?",
      MontantBourseAnnuelle: "Le montant de la bourse annuelle",
      CompteEpargne:
        "Vos parents, votre tuteur légal ou vous-même, possédez-vous des comptes épargnes ?",
      MontantEpargne: "Le montant total de l'épargne",
      ValeurImmobiliere:
        "Vos parents ou tuteur légal sont-ils porteurs/ souscripteurs de valeurs mobilières (actions, obligations, OPCVM, etc.)",
      ValeurImmobiliereItem: "Valeurs mobilière",
      ValeurTotaleTitres: "La valeur totale de ces titres",
      ChargeFraisUniv: "Prise en charge des frais universitaire",
      MontantBourse: "Le montant total annuel",
      CompteEpargneItem: "Compte épargne",
      DepotsTermes:
        "Vos parents ou votre tuteur légal possèdent-ils des dépôts à terme * ? Le Dépôt À Terme est une somme d’argent bloquée auprès d’une banque, pour une période déterminée, produisant des intérêts en faveur du souscripteur (déposant).",
      DepotsTermesItem: "Dépôts à terme * ? ",
      MontantDuCapital: "Préciser le montant du capital",
      CompleterRevenus: "Compléter les revenus ",
      AjouterCredits: "Ajouter la liste des crédits pour ",
      AjouterBiensImmo: "Ajouter la liste des biens immobiliers pour ",
    },
    Revenus: {
      Headers: [
        { text: "Lien parenté", value: "parente" },
        { text: "Voir les détails", value: "actions", sortable: false },
      ],
      RenseignerTousLesChamps:
        "Tous les champs doivent être renseignés même si nuls.",
      RenseignerRevenus: "Renseigner les revenus",
      RevenuMensuelNetDeclare: "Revenu mensuel net declaré (1)",
      HorsPension: "Hors pension de retraite et de veuvage",
      RevenuNetAnnuelAttestation:
        "Revenu Net Imposable Annuel figurant sur l'attestation Salaire annuel",
      RevenuNetMensuelAttestation:
        "Revenu Net Mensuel figurant sur l'attestation Salaire annuel",
      PhraseExplicativeRevenuNetMensuelAttestation:
        "Diviser le revenu net annuel figurant sur l'attestation Salaire annuel sur / 12",
      RevenuNetMensuelBulletinRecent:
        "Revenu Net Mensuel figurant sur le bulletin de paie le plus récent",
      RevenuNetMensuelBulletinDecembre:
        "Revenu Net Mensuel figurant sur le bulletin de paie de décembre N-1",
      SommeMensuelPensions:
        "Somme des Revenus Nets Mensuels figurant sur toutes les attestations de toutes les pensions perçues",
      AllocationPere:
        "Allocations familiales (versées par le père aux enfants)",
      PensionMere:
        "Somme des Revenus Nets Mensuels figurant sur toutes les attestations de toutes les pensions perçues par la mère",
      RevenuNetAnnuelDgi:
        "Revenu Net Imposable Annuel figurant sur l'attestation DGI",
      AutreRevenuNetAnnuel: "Autre revenu net mensuel (2)",
      Note1:
        "(1) salaires nets, honoraires, CIMR, et autres pensions, rentes, loyers mensuels, autres revenus mensuels … (les revenus mensuels nets ne doivent pas tenir compte des dépenses spécifiques tels que les crédits, les personnes à charge et autres dépenses personnelles).",
      Note2:
        "(2) autre que :revenus agricoles, dividendes, revenus locatifs, autres revenus nets annuels perçus, produits résultants de la vente de biens immobiliers, héritages et autres revenus exceptionnels.",
      RevenuAnnuelGlobal:
        "Revenus annuels comme figurent sur l'attestation du revenu global.",
      NatureDesRevenus: "Nature des revenus",
      CAHT: "Chiffre d'affaires déclaré H.T",
      MontantRevenuNetImp: "Montant du revenu net imposable",
      Employeur: "Nom ou raison sociale de l'employeur",
      RevenusProfessionnels: "Revenus professionnels",
      RevenusAgricoles: "Revenus agricoles",
      RevenusSalariaux: "Revenus salariaux et assimilés",
      RevenusFonciers: "Revenus fonciers",
      RevenusCapitauxImmo: "Revenus de capitaux mobiliers",
      RevenusSourcesEtrangeres: "Revenus et profits de sources étrangères",
      RevenusCompleterTuteurs:
        "Les revenus à compléter portent sur les parents/tuteurs où la rubrique'Tuteur(rice)' est \"Oui\"",
      ModeleAttestationSalarie:
        "Modèle Attestation Salaire Annuel que pour les salariés",
      ModeleAttestationDgi: "Modèle Attestation Revenus DGI",
      InfoRenseignementChampsObligatoire: "Tout les champs obligatoires ne sont pas été renseigné.",
    },
    AutresRevenus: {
      HeadersTab: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Lien parenté", value: "lienparente" },
        { text: "Total revenus mensuels en dirhams", value: "trmd" },
        { text: "Total autres revenus annuels en dirhams", value: "tarad" },
        { text: "Total revenus exceptionnels en dirhams", value: "tred" },
        { text: "", value: "actions", sortable: false },
      ],
      RevenusLocatifNef: "Revenu locatif net annuel",
      RevenuNetMensuelDirham: "Revenus mensuels en dirhams",
      RevenuNetMensuelMoyen: "Revenu / salaire net mensuel moyen (*)",
      Inclure13Mois:
        "(Il faut inclure le 13 éme mois et les primes et gratifications annuelles)",
      PensionNetteMensuelleRetraire:
        "Pension nette menuselle (en cas de retraite)",
      PensionVeuvage:
        "Pension de veuvage nette mensuelle (en cas de décès de l'un des parents)",
      AllocationDivorce:
        "Allocations familales nettes mensuelles (en cas de divorce)",
      RevenuLocatif: "Revenu locatif net mensuel",
      AutresRevenusNetMensuel: "Autres revenus nets mensuels perçus",
      TotalRevenusNetsMensuels: "Total revenus nets mensuels",
      AutresRevenusAnnuelsDirham: "Autres revenus annuels en dirhams",
      AutresRevenusTitle: " reçu durant l’année ",
      RevenusAgricolesAnnuels: "Revenus agricoles annuels nets",
      Dividendes: "Dividendes (1)",
      AutreRevenusNetAnnuels: "Autres revenus nets annuels perçus",
      PrecisezLaNature: "(Il faut préciser la nature du revenu)",
      PrecisezLaNatureExc: "Pécisez la nature du revenu exceptionnel",
      TotalAutresRevenusAnnuel: "Total autres revenus annuels",
      RevenuExceptionnels: "Revenus exceptionnels en dirhams",
      NatureAutresRevenus: "Nature des autres revenus",
      ProduitVenteImmo: "Produits résultant de la vente de biens immobiliers",
      Heritages: "Héritages",
      AutresRevenusExceptionnels: "Autres revenus exceptionnels perçus",
      TotalRevenusExceptionnels: "Total revenus exceptionnels",
      NB1: "N.B. : Insérer « 0 » dans les champs qui ne s'appliquent pas à votre situation.",
      NB2: "(*) Les revenus mensuels nets ne doivent pas tenir compte des dépenses spécifiques tels que les crédits, les personnes à charge et autres dépenses personnelles.",
      NB3: "(1) Bénéfice versé par une société à un actionnaire.",
      LabelTableauCredit:
        "Si vos parents ou votre tuteur légal ont des crédits auprès d'établissements de crédit, veuillez remplir le tableau ci-dessous :",
      TypeFinancement: "Type de financement (1)",
      MontantGlobal: "Montant global",
      Duree: "Durée en mois",
      MontantEcheance: "Montant d'échéance",
      LabelTableauBiensImmo:
        "Vos parents ou votre tuteur légal êtes-vous propriétaires de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc",
      Proprietaire: "Propriétaire",
      NombreBiens: "Nombre de biens",
      NatureBien: "Nature du bien",
      AdresseBien: "Adresse du bien",
      NumeroTitreFoncier: "Numéro du titre foncier",
      DateAcquisitionBien: "Date d’acquisition du bien",
      ValeurAcquisitionBien: "Valeur d’acquisition du bien",
      ValeurEstimativeBien: "Valeur estimative actuelle du bien",
      SourceEstimationBien: "Source d’estimation de la valeur actuelle du bien",
      RevenuBien:
        "Si le bien génère un revenu locatif, veuillez préciser le revenu",
      SuperficieBien: "Superficie du bien en m2",
      CandidatProprietaire:
        "Etes-vous propriétaire de biens immobiliers secondaires, de terrains, de fermes, de locaux commerciaux ou de fonds de commerce, etc ?",
      PopupNBBienImmo:
        "N.B. : Ce tableau concerne uniquement les biens autres que la résidence principale du foyer.<br>Renseigner uniquement les biens immobiliers secondaires. <br>Terrain, bien immobilier, local commercial, etc.<br>Superficie de la villa, Superficie terrain agricole, superficie de l’appartement, R+1, R+2, R+3, etc.<br>Source d’estimation de la valeur actuelle du bien : Notaire, expert immobilier agréé, cadastre/ direction générale des impôts, etc.<br>Si vous possédez un bien en copropriété (partagé avec un ou plusieurs autres propriétaire), veuillez indiquer uniquement la valeur estimative actuelle de votre part dans ce bien.",
      PopupNBBienImmoECC:
        "N.B. : Ce tableau concerne uniquement les biens autres que la résidence principale du foyer. <br>Terrain, bien immobilier, local commercial, etc.<br>Superficie de la villa, Superficie terrain agricole, superficie de l’appartement, R+1, R+2, R+3, etc.<br>Source d’estimation de la valeur actuelle du bien : Notaire, expert immobilier agréé, cadastre/ direction générale des impôts, etc.<br>Si vous possédez un bien en copropriété (partagé avec un ou plusieurs autres propriétaire), veuillez indiquer uniquement la valeur estimative actuelle de votre part dans ce bien.",
      RenseignementRevenuMensuel: "Veuillez renseigner le revenu mensuel déclaré",
      RenseignementRevenuMensuelPension: "Veuillez renseigner le revenu mensuel déclaré et la pension de retraite",
      RenseignementPensionRentraite: "Veuillez renseigner la pension de retraite",
      AdressePrincipaleCompte: "Cette adresse sera utilisée comme adresse principale de votre compte et servira pour la réinitialisation de votre mot de passe."
    },
    Bourse: {
      HeadersTab: [
        { text: "Organisme", value: "organisme" },
        { text: "Début", value: "debut" },
        { text: "Fin", value: "fin" },
        { text: "Montant annuel en DHS", value: "montantdirham" },
        { text: "", value: "actions", sortable: false },
      ],
    },
  },
  LabelEN: {
    Valider: "Confirm",
    Annuler: "Cancel",
    Ajouter: "Add",
    Modifier: "Edit",
    Suivant: "Next",
    Enregistrer: "Save",
    Soumettre: "Submit my application",
    Precedent: "Previous",
    SupprimerLigne: "Are you sure you want to delete this line ?",
    AfficherDocument: "View document",
    Informations: "Informations",
    Fermer: "Close",
    Oui: "Yes",
    Non: "No",
    Resume: "Summary of your enquiry",
    Annexes: {
      TailleMaximale: "Maximum file size: 4MB",
      TailleMaximaleDepassee: "Maximum file size exceeded.",
      AnnexesObligatoires: "Attachments - Please add all mandatory attachments",
      SoumissionAnnexes: 'Please submit the attachments on the "Document" tab',
      AjouterPj: "Add an attachment",
      TypePiece: "Type of attachment",
      SelectionnerDocument: "Select your document",
      FormatsAcceptes: "Accepted formats: pdf and images (jpg, jpeg et png)",
      FormatsAcceptesPdf: "Accepted formats: pdf only",
      FichierSelectionne: "Selected file :",
      AfficherDocument: "View document",
      ListeVide: "The list is empty",
      FichierManquant: "Missing file",
      SupprimerDocument: "Are you sure you want to delete this document?",
      FormatNonSupporte: "Format not supported",
      VeuillezTelecharger: "Please download",
      CeDocument: "this file",
      SignerDeposer:
        "in order for it to be signed and legalised by the candidate and their parents or guardian (if applicable), then submitted in the following section",
      Header: [
        { text: "Attachment's type", value: "type" },
        { text: "File", value: "fichier" },
        { text: "Mandatory", value: "obligatoire" },
        {
          text: "Electronic conformity",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    },
    StepperHeaders: [
      "Introduction",
      "Candidate",
      "Siblings",
      "Parents / Tutors",
      "Revenue",
      "Finally",
    ],
    Title: {
      Candidat: "Candidat",
      Adresses: "Addresses",
      EtatFamilial: "Family situation",
      SituationFinanciere: "Financial situation of the candidate",
      Bourse: "Bourse",
      Fratrie: "Siblings",
      SituationFamiliale: "Family situation",
      Revenus: "Revenue",
    },
    Candidat: {
      Nom: "Last name",
      Prenom: "Firstname",
      Genre: "Gender",
      DateNaissance: "Date of birth",
      LieuNaissance: "Place of birth",
      SituationFamiliale: "Family status",
      Nationalite: "Nationality",
      AutreNationalite: "Other nationality",
      Mail: "Email",
      Cni: "N° CNI",
      NoPasseport: "N° passport",
      Portable: "Phone number",
      Fixe: "Fix number",
      SituationHandicap: "Disabilities",
      TypeHandicap: "Type of disability",
      AdresseMaroc: "Address",
      AdresseMa: "Address in Maroc",
      Adresses: "Addresses",
      AdresseAu: "Other address",
      VilleMaroc: "City",
      ProvinceMaroc: "Province",
      RegionMaroc: "Région",
      CpMaroc: "Zip code",
      PaysMaroc: "Country",
      AdresseAutre: "Address",
      VilleAutre: "City",
      RegionFrance: "Région",
      DepartementFrance: "Departement",
      CpAutre: "Zip code",
      PaysAutre: "Country",
      EtesVous: "Are-you ?",
      GardeConfiee: "Parental custody belongs to ",
      ParentTuteurDivorce: "Divorced parent/guardian",
      ParentTuteurVeuf: "Widowed guardian parent",
      VousEtes: "You are :",
      RevenuNetMensuel: "Net monthly income",
      ProtectionSociale: "Do you have a social protection scheme? ",
      OrganismeProtectionSociale: "If yes, please specify which organisation",
      NombreCompteBancaire: "Number of bank accounts",
      BourseSupplementaire:
        "Do you receive an additional grant for your studies? ",
      Beneficiaire: "Are you a beneficiary of a Mastercard Foundation grant? ",
      NomAutreBourse: "Organisation's name",
      MontantAnnuelDirham: "Annual amount in dirham",
      DateFinBourse: "End date of this grant",
      DateDebutBourse: "Start date of this grant",
    },
    Fratrie: {
      HeadersTab: [
        { text: "Lastname", value: "nom" },
        { text: "Firstname", value: "prenom" },
        { text: "Date of birth", value: "datenaissance" },
        { text: "En situation de handicap", value: "situationhandicap" },
        { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],
      Nom: "Nom",
      Prenom: "Prénom",
      DateNaissance: "Date de naissance",
      SituationHandicap: "Disabilities ?",
      TypeHandicap: "Type of Disability",
      NomPere: "Father's fullname",
      NomMere: "Mother's fullname",
      MsgDoublon: "A person with the same last name, first name and date of birth already exists in the list.",
    },
    Parents: {
      HeadersTab: [
        { text: "Lastname", value: "nom" },
        { text: "Firstname", value: "prenom" },
        { text: "Family link", value: "lienparente" },
        { text: "Family status", value: "situationfamiliale" },
        { text: "", value: "actions", sortable: false },
      ],
      LienParenteTuteur: "Legal Tutor's family relationship",
      MsgSituationParents:
        "If you have indicated that you are dependent on two married parents, please correct your parents' marital status.",
      MsgSituationParentVeuf:
        "Please fill in all required fields for the deceased parent.",
      MsgParentsMaries:
        "If you have indicated that you are dependent on two married parents, please add both your parents here.",
      MsgParentVeuf:
        "If you have indicated that you are dependent on one of two widow parents, please add both your parents here.",
      MsgTuteur:
        "Please enter at least one legal tutor. In this case, please return to the ‘Personal details’ stage and select the option ‘Orphan of both parents, without legal guardian and/or dependent on an orphanage’ in the ‘Applicant’ section.",
      MsgTuteurMere:
        "You have indicated that you are dependent on your mother. Please check your entry.",
      MsgTuteurPere:
        "You have indicated that you are dependent on your father. Please check your entry.",
      DateDepartRetraite: "Retirement date",
      Tuteur: "Legal Tutor",
      Nom: "Lastname",
      Prenom: "Firstname",
      Civilite: "Civility",
      Nationalite: "Nationality",
      AutreNationalite: "Other nationality",
      SituationFamiliale: "Family status",
      Cni: "N° CNI",
      AutreCni: "National identity document number/passport number",
      NoPasseport: "N° passeport",
      LienParental: "Familiy linl",
      SituationHandicap: "Disabilities ?",
      TypeHandicap: "Type of disability",
      AdresseElectronique: "Email",
      AdressePermanante: "Permanent address",
      AdresseSecondaire: "Secondary address",
      Portable: "Phone number",
      Fixe: "Landline",
      //Situationfinanciere
      TypeOrganisme: "Type of organisation",
      BeneficiaireAssurance:
        "Beneficiary of supplementary health insurance/supplementary pension ?",
      Mutuelle: "Mutual insurance",
      Secteur: "Professional sector",
      Profession: "Profession",
      EtatProfessionnel: "Professional status",
      SituationProfessionnel: "Professional situation",
      NomEmployeur: "ame of organisation or employer",
      RnmNet: "Monthly net income if other than non-active",
      AMO_TADAMON: "Do you have a social protection scheme AMO TADAMON? ",
      RegimeProtection:"Do you have a social protection scheme?",
      AutreRegimeProtection:
        "If not, do you have another social protection scheme? ",
      SituationASaisir:
        "Do your parents or legal guardian have any credit with credit institutions?",
      BienImmoSecondaireParentsTuteurs:
        "Do your parents or legal guardian own secondary real estate, land, farms, commercial premises or businesses, etc.?",
      QuelOrganisme: "If yes, please specify which organisation ",
      NombreCompteBancaire: "Number of bank accounts",
      PreciserSociete: "Specify company name",
      AssocieOuGerantSociete:
        "Is this parent a partner or managing partner in a company? ",
      FraisUnivEmployeur:
        "Do your parents or legal guardians have all or part of their children's university fees paid for by their employers?",
      MontantBourseAnnuelle: "The amount of the annual grant",
      CompteEpargne:
        "Do you, your parents or your legal guardian have savings accounts?",
      MontantEpargne: "The total amount of savings",
      ValeurImmobiliere:
        "Are your parents or legal guardians holders/subscribers of securities? (shares, bonds, mutual fund, etc.)",
      ValeurTotaleTitres: "The total value of these securities",
      ChargeFraisUniv: "Payment of university fees",
      MontantBourse: "The total annual amount",
      ValeurImmobiliereItem: "Transferable securities",
      CompteEpargneItem: "Savings account",
      DepotsTermes:
        "Do your parents or legal guardian have term deposits *? The Term Deposit is a sum of money blocked with a bank, for a specific period, producing interest in favor of the subscriber (depositor).",
      MontantDuCapital: "Specify the amount of the capital",
      CompleterRevenus: "Enter all income details ",
      AjouterCredits: "Add the list of credits for ",
      AjouterBiensImmo: "Add the list of properties for ",
    },
    Revenus: {
      Headers: [
        { text: "Family link", value: "parente" },
        { text: "Show details", value: "actions", sortable: false },
      ],
      RenseignerTousLesChamps:
        "All fields must be filled in, even if they are null..",
      RenseignerRevenus: "Enter income",
      RevenuMensuelNetDeclare: "Declared net monthly income (1)",
      HorsPension: "Excluding retirement and widows' pensions",
      RevenuNetAnnuelAttestation:
        "Net annual taxable income shown on certificate Annual salary",
      RevenuNetMensuelAttestation:
        "Net monthly taxable income shown on certificate Annual salary",
      PhraseExplicativeRevenuNetMensuelAttestation:
        "Divide the annual net income shown on the Annual Salary certificate by / 12",
      RevenuNetMensuelBulletinRecent:
        "Monthly net income as shown on the most recent pay slip",
      RevenuNetMensuelBulletinDecembre:
        "Monthly net income shown on the December pay slip N-1",
      SommeMensuelPensions:
        "Sum of Net Monthly Income shown on all certificates for all pensions received",
      AllocationPere: "Child benefit (paid by the father to the children)",
      PensionMere:
        "Sum of Net Monthly Income shown on all certificates for all pensions received by the mother",
      RevenuNetAnnuelDgi:
        "Annual net taxable income shown on the DGI certificate",
      AutreRevenuNetAnnuel: "Other monthly net income (2)",
      Note1:
        "(1) net salaries, fees, CIMR, annuities, monthly rents, other monthly income, etc. (net monthly income must not take into account specific expenses such as loans, dependents and other personal expenses).",
      Note2:
        "(2) other than: agricultural income, dividends, rental income, other net annual income received, proceeds from the sale of property, inheritances and other exceptional income.",
      RevenuAnnuelGlobal:
        "Annual income as shown on the global income certificate.",
      NatureDesRevenus: "Type of income",
      CAHT: "Declared sales excluding VAT",
      MontantRevenuNetImp: "Amount of net taxable income",
      Employeur: "Name or company name of employer",
      RevenusProfessionnels: "Income from professional activities",
      RevenusAgricoles: "Farm income",
      RevenusSalariaux: "Salary or equivalent income",
      RevenusFonciers: "Property income",
      RevenusCapitauxImmo: "Income from transferable securities",
      RevenusSourcesEtrangeres: "Income and profits from foreign sources",
      RevenusCompleterTuteurs:
        'The income to be completed relates to parents/guardians where the "Guardian" field is "Yes".',
      ModeleAttestationSalarie:
        "Model Annual Salary Statement for employees only",
      ModeleAttestationDgi: "Model DGI Income Statement",
      InfoRenseignementChampsObligatoire: "Not all required fields have been completed.",
    },
    AutresRevenus: {
      HeadersTab: [
        { text: "Lastname", value: "nom" },
        { text: "Firstname", value: "prenom" },
        { text: "Family link", value: "lienparente" },
        { text: "Total monthly income in dirhams", value: "trmd" },
        { text: "Total other annual income in dirhams", value: "tarad" },
        { text: "Total exceptional income in dirhams", value: "tred" },
        { text: "", value: "actions", sortable: false },
      ],
      RevenusLocatifNef: "Revenu locatif net annuel",
      RevenuNetMensuelDirham: "Monthly income in dirhams",
      RevenuNetMensuelMoyen: "Average monthly net income/salary (*)",
      Inclure13Mois: "(13th month and annual bonuses must be included)",
      PensionNetteMensuelleRetraire: "Net monthly pension (if retired)",
      PensionVeuvage:
        "Net monthly widow's pension (in the event of the death of one of the parents)",
      AllocationDivorce: "Net monthly child benefit (if divorced)",
      RevenuLocatif: "Net monthly rental income",
      AutresRevenusNetMensuel: "Other net monthly income received",
      TotalRevenusNetsMensuels: "Total net monthly income",
      AutresRevenusAnnuelsDirham: "Other annual income in dirhams",
      AutresRevenusTitle: " received during the year ",
      RevenusAgricolesAnnuels: "Net annual farm income",
      Dividendes: "Dividend (1)",
      AutreRevenusNetAnnuels: "Other net annual income received",
      PrecisezLaNature: "(please specify the nature of the income)",
      PrecisezLaNatureExc: "Specify the nature of the exceptional income",
      TotalAutresRevenusAnnuel: "Total other annual income",
      RevenuExceptionnels: "Exceptional income in dirhams",
      NatureAutresRevenus: "Nature of other income",
      ProduitVenteImmo: "Income from the sale of property",
      Heritages: "Heritage",
      AutresRevenusExceptionnels: "Other exceptional income received",
      TotalRevenusExceptionnels: "Total exceptional income",
      NB1: 'N.B.: Insert "0" in fields that do not apply to your situation.',
      NB2: "(*) Net monthly income should not take into account specific expenses such as loans, dependants and other personal expenses.",
      NB3: "(1) Profit paid by a company to a shareholder.",
      LabelTableauCredit:
        "If your parents or legal guardian have loans with credit institutions, please complete the table below :",
      TypeFinancement: "Type of financing (1)",
      MontantGlobal: "Total amount",
      Duree: "Duration",
      MontantEcheance: "Amount at each due date",
      LabelTableauBiensImmo:
        "Do you, your parents or your legal guardian own secondary real estate, land, farms, business premises, etc.?",
      Proprietaire: "Owner",
      NombreBiens: "Number of properties",
      NatureBien: "Type of property",
      AdresseBien: "Property address",
      NumeroTitreFoncier: "Land title number",
      DateAcquisitionBien: "Date of acquisition of the property",
      ValeurAcquisitionBien: "Acquisition value of the property",
      ValeurEstimativeBien: "Current estimated value of the property",
      SourceEstimationBien:
        "Source of estimation of the current value of the property",
      RevenuBien:
        "If the property generates rental income, please specify the income",
      SuperficieBien: "Surface area of the property",
      CandidatProprietaire:
        "Do you own secondary real estate, land, farms, commercial premises or business, etc.?",
      PopupNBBienImmo:
        "N.B.: This table only concerns assets other than the household's main residence.<br>Only secondary real estate should be reported.<br>1. Land, real estate, commercial premises, etc.<br>2. Surface area of ​​the villa, Surface area of ​​agricultural land, Surface area of ​​the apartment, R+1, R+2, R+3, etc.<br>3. Source of estimation of the current value of the property: Notary, certified real estate expert, land registry/general tax directorate, etc.<br>4. If you own a property in co-ownership (shared with one or more other owners), please indicate only the current estimated value of your share in this property.",
      PopupNBBienImmoECC:
        "N.B.: This table only concerns assets other than the household's main residence. <br>1. Land, real estate, commercial premises, etc.<br>2. Surface area of ​​the villa, Surface area of ​​agricultural land, Surface area of ​​the apartment, R+1, R+2, R+3, etc.<br>3. Source of estimation of the current value of the property: Notary, certified real estate expert, land registry/general tax directorate, etc.<br>4. If you own a property in co-ownership (shared with one or more other owners), please indicate only the current estimated value of your share in this property.",
      RenseignementRevenuMensuel: "Please enter the declared monthly income",
      RenseignementRevenuMensuelPension: "Please enter the declared monthly income and pension",
      RenseignementPensionRentraite: "Please enter the retirement pension",
      AdressePrincipaleCompte: "This address will be used as the main address of your account and will be used for resetting your password."
      },
    Bourse: {
      HeadersTab: [
        { text: "Organization", value: "organisme" },
        { text: "Start", value: "debut" },
        { text: "End", value: "fin" },
        { text: "Annual amount in DHS", value: "montantdirham" },
        { text: "", value: "actions", sortable: false },
      ],
    },
  },
  ChargerFormulaire(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get(`candidatureBourseFirsi/Formulaire?ecoleCentrale=${false}`);
  },
  async SaveEtape(token, etape) {
    try{
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("candidatureBourseFirsi/SaveEtape/" + etape, this.Formulaire);

      // Affectation des données avec vérification
      if (reponse.data && reponse.status === 200) {
        return reponse.data;
      }
      else{
        return "error";
      }
    }
    catch(error){
      console.log("Erreur : ", error);
      return "error";
    }
  },
  Signer(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("candidatureBourseFirsi/Signer", this.Formulaire);
  },
  async Publiposter(token) {
    try{
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("candidatureBourseFirsi/Publiposter/" + this.Formulaire.Id);

      if(reponse && reponse.status === 200){
        return reponse;
      }
      else{
        return "error";
      }
    }
    catch(error){
      console.log("Erreur : ", error);
      return "error";
    }
     
  },
  ParseToFormulaire(dto, storeCommun) {
    if (dto) {
      // Sauvegarder conditionsGenerales avant parsing (non mappé côté backend)
      const conditionsGeneralesBackup = this.Formulaire.ConditionsGenerales;
      
      this.Formulaire.ReadOnly = dto.readOnly;
      storeCommun.ReadOnly = dto.readOnly;
      this.Formulaire.LienDocumentDgi = dto.lienDocumentDgi;
      this.Formulaire.LienDocumentSalaire = dto.lienDocumentSalaire;
      this.Formulaire.PublipostageSigne = {
        NomFichier: null,
        DonneePieceJointe: null,
      };
      this.Formulaire.AdresseAutre = dto.adresseAutre;
      this.Formulaire.AdresseMaroc = dto.adresseMaroc;
      this.Formulaire.AutreNationalite = dto.autreNationalite;
      this.Formulaire.Cni = dto.cni;
      this.Formulaire.CpAutre = dto.cpAutre;
      this.Formulaire.CpMaroc = dto.cpMaroc;
      this.Formulaire.DateNaissance = storeCommun.ConvertDateApiToDateVue(
        dto.dateNaissance
      );
      this.Formulaire.Fixe = dto.fixe;
      this.Formulaire.Genre = dto.genre;
      this.Formulaire.Id = dto.id;
      this.Formulaire.LieuNaissance = dto.lieuNaissance;
      this.Formulaire.Mail = dto.mail;
      this.Formulaire.Nationalite = dto.nationalite;
      this.Formulaire.Nom = dto.nom;
      this.Formulaire.PaysAutre = dto.paysAutre;
      this.Formulaire.PaysMaroc = dto.paysMaroc;
      this.Formulaire.Portable = dto.portable;
      this.Formulaire.Prenom = dto.prenom;
      this.Formulaire.SituationHandicap = dto.situationHandicap;
      this.Formulaire.TypeHandicap = [];
      this.Formulaire.VilleAutre = dto.villeAutre;
      this.Formulaire.VilleMaroc = dto.villeMaroc;
      this.Formulaire.SituationFamiliale = dto.situationFamiliale;
      this.Formulaire.ProvinceMaroc = dto.provinceMaroc;
      this.Formulaire.RegionMaroc = dto.regionMaroc;
      this.Formulaire.DepartementFrance = dto.departementFrance;
      this.Formulaire.RegionFrance = dto.regionFrance;
      storeCommun.AnneeRevenus = dto.anneeScolaireAutresRevenus?.lang00; // REVAMPING UM6P
      this.Formulaire.BourseSupplementaire = dto.bourseSupplementaire;
      this.Formulaire.Beneficiaire = dto.beneficiaire;
      // Gérer conditionsGenerales (non mappé côté backend)
      if (dto.id || dto.idCrypte) {
        // Dossier existant : restaurer la valeur ou forcer à true si premier chargement
        this.Formulaire.ConditionsGenerales = conditionsGeneralesBackup !== false ? conditionsGeneralesBackup : true;
      }
      // Sinon pour nouveau dossier, reste à false (valeur par défaut du store)
      Object.assign(this.Formulaire.TypeHandicap, dto.typeHandicap);

      storeCommun.DateAgeFratrie = dto.dateAgeFratrie;

      // infos complementaire
      storeCommun.ParseInfosCandidature(dto.infosComplementaires);

      // Autre revenus candidat
      storeCommun.ListeAutresRevenus = [];
      if (dto.listeProprietesCandidat) {
        dto.listeProprietesCandidat.forEach((element) => {
          let propriete = storeCommun.ParseAutreRevenu(element);
          storeCommun.ListeAutresRevenus.push(propriete);
        });
      }

      if (dto.autresRevenusCandidat) {
        storeCommun.ParseAutresRevenusDto(dto.autresRevenusCandidat);
      }

      // Liste parents
      storeCommun.ListeSituationsFamiliale = [];
      if (dto.listeSituationsFamiliale) {
        dto.listeSituationsFamiliale.forEach((element) => {
          let parent = storeCommun.ParseSituationFamilialeDto(element);
          storeCommun.ListeSituationsFamiliale.push(parent);
        });
      }

      // Liste fratrie
      storeCommun.ListeFratrie = [];
      if (dto.listeFratrie) {
        dto.listeFratrie.forEach((element) => {
          let fratrie = storeCommun.ParseFratrieDto(element);
          storeCommun.ListeFratrie.push(fratrie);
        });
      }
      // Liste bourse
      storeCommun.ListeAutresBourses = [];
      if (dto.listeAutresBourses) {
        dto.listeAutresBourses.forEach((element) => {
          let bourses = storeCommun.ParseBourseDto(element);
          storeCommun.ListeAutresBourses.push(bourses);
        });
      }

      // Liste annexes
      this.Formulaire.ListeAnnexesFirsi = [];
      if (dto.listeAnnexesFirsi) {
        dto.listeAnnexesFirsi.forEach((element) => {
          let annexe = this.ParseAnnexeDto(element);
          this.Formulaire.ListeAnnexesFirsi.push(annexe);
        });
      }
    }
  },
  ParseAnnexeDto(element) {
    var annexe = {
      Supprimer: false,
      IdCrypte: element.idCrypte,
      Editable: element.editable,
      ObligatoireSoumettre: element.obligatoireSoumettre,
      LabelFormulaire: element.labelFormulaire ?? element.nomDocument?.lang00,
      LabelFormulaireEn:
        element.labelFormulaireEn ?? element.nomDocument?.lang01,
      AnneeScolaire: {
        Id: element.anneeScolaire?.id,
        Lang00: element.anneeScolaire?.lang00,
        Lang01: element.anneeScolaire?.lang01,
      },
      ConformiteElectronique: {
        Id: element.conformiteElectronique?.id,
        Lang00: element.conformiteElectronique?.lang00,
        Lang01: element.conformiteElectronique?.lang01,
      },
      ConformitePhysique: {
        Id: element.conformitePhysique?.id,
        Lang00: element.conformitePhysique?.lang00,
        Lang01: element.conformitePhysique?.lang01,
      },
      NatureDocument: {
        Id: element.natureDocument?.id,
        Lang00: element.natureDocument?.lang00,
        Lang01: element.natureDocument?.lang01,
      },
      NomDocument: {
        Id: element.nomDocument?.id,
        Lang00: element.nomDocument?.lang00,
        Lang01: element.nomDocument?.lang01,
      },
      NomFichier: element.nomFichier,
      DonneePieceJointe: element.donneePieceJointe,
      NonConformeElectronique: element.nonConformeElectronique,
      NonConformePhysique: element.nonConformePhysique,
      CandidatureBourseId: element.candidatureBourseId,
      PpId: element.ppId,
      TemplateAnnexeFirsi: element.templateAnnexeFirsi,
      TypeDeDocument: {
        Id: element.typeDeDocument?.id,
        Lang00: element.typeDeDocument?.lang00,
        Lang01: element.typeDeDocument?.lang00,
      },
      UrlFichier: element.urlFichier,
      Fratrie: element.fratrie,
      SituationFamiliale: element.situationFamiliale,
      Etape: element.etape,
      IndexFratrie: element.indexFratrie,
      IndexSituationFamiliale: element.indexSituationFamiliale,
    };

    return annexe;
  },
  AffecterStoreCommun(storeCommun) {
    if (storeCommun) {
      this.Formulaire.ListeFratrie = storeCommun.ListeFratrie;
      this.Formulaire.ListeAutresBourses = storeCommun.ListeAutresBourses;
      this.Formulaire.ListeSituationsFamiliale =
        storeCommun.ListeSituationsFamiliale;
      this.Formulaire.InfosComplementaires = storeCommun.InfosCandidature;
      this.Formulaire.ListeProprietesCandidat = storeCommun.ListeAutresRevenus;
      this.Formulaire.AutresRevenusCandidat = storeCommun.AutreRevenuDto;
    }
  },
};
